// extracted by mini-css-extract-plugin
export default {"toast":"CustomToast_toast__vh1Hk","toastError":"CustomToast_toastError__Ii9be","toastWarning":"CustomToast_toastWarning__yI-7k","toastClose":"CustomToast_toastClose__PvHuG"};